var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.$vuetify.breakpoint.xsOnly || _vm.$vuetify.breakpoint.smOnly)?_c('MobileHeader',{attrs:{"juba":_vm.juba}}):_c('DesktopHeader',{attrs:{"juba":_vm.juba}}),_c('v-content',[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }